import { FC } from 'react';

import { Box, CircularProgress, Typography, useTheme } from '@mui/material';

interface LoadingProps {
    message?: string;
    size?: number;
}

export const Loading: FC<LoadingProps> = ({ message = 'Loading...', size = 48 }) => {
    const theme = useTheme();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 2,
                p: 4,
            }}
        >
            <CircularProgress
                size={size}
                thickness={4}
                sx={{
                    color: theme.palette.primary.main,
                }}
            />
            {message && (
                <Typography
                    variant="body2"
                    sx={{
                        color: theme.palette.text.secondary,
                    }}
                >
                    {message}
                </Typography>
            )}
        </Box>
    );
};
